import Request from './request'

const Device_Traffic_Alerts = {
  getDeviceTrafficAlerts(params, callback) {
    Request.post('device-traffic-alerts',JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Device_Traffic_Alerts
